import React from 'react';
import { observer } from 'mobx-react';
import { Alert } from '@material-ui/lab';
import { useAuthStore } from '../AuthStore';

const AuthenticatedAlert = (): React.ReactElement => {
  const store = useAuthStore();
  return (
    store.isAuthenticated ? <Alert severity="success">User is authenticated</Alert> : <Alert severity="warning">User is not authenticated</Alert>
  );
}

export default observer(AuthenticatedAlert);
